import { get } from "lodash";

export default (fieldId, fields) =>
  get(fields.find(f => f.id === fieldId), "module_field_id");
